type metaType = { alias: string; name: string };

export const meta: metaType = {
  alias: 'weather',
  name: 'Weather'
};
